import { type FC, type SyntheticEvent } from "react";

import { Enrollment } from "../../../enums/groups";
import { Strings } from "../../../enums";
import { EllipsisPopup, type EllipsisPopupOption } from "../../buttons/ellipsisPopup/EllipsisPopup";
import { type Group, type GroupActionHandlers } from "../../../interfaces";
import { getAddContentEllipsisPopupOptions } from "../addContentButtonEllipsisOptions/AddContentButtonEllipsisOptions";
import { partial } from "lodash";

export interface Props extends GroupActionHandlers {
  group: Group;
  disabled: boolean;
  hasManagePermissions: boolean;
}

const GroupEllipsisPopupButton: FC<Props> = ({
  group,
  disabled,
  onAddMembers,
  onAddToContent,
  onDelete,
  onDuplicate,
  onEdit,
  hasManagePermissions,
}) => {
  const contentOptions: EllipsisPopupOption[] = [
    {
      label: "Edit",
      iconName: "fal fa-edit",
      isHideItem: !hasManagePermissions,
      onClick: () => onEdit?.(group.id),
    },
    {
      label: Strings.modalTitles.addContent,
      iconName: "far fa-plus-circle",
      isHideItem: !hasManagePermissions,
      options: getAddContentEllipsisPopupOptions(partial(onAddToContent!, group.id)),
    },
    {
      label: "Duplicate",
      iconName: "fal fa-copy",
      onClick: () => onDuplicate?.(group.id),
    },
    {
      label: "Add People",
      iconName: "far fa-plus-circle",
      isHideItem: group.isWithAutoEnroll === Enrollment.Automatic || !group.canEdit,
      onClick: () => onAddMembers?.(group.id),
    },
    {
      label: "Delete",
      iconName: "fal fa-trash-alt",
      isHideItem: !hasManagePermissions,
      onClick: () => onDelete?.(group.id),
    },
  ];

  return (
    <div onClick={(e: SyntheticEvent) => e.preventDefault()}>
      <EllipsisPopup options={contentOptions} disabled={disabled} testId="group-overflow-menu-button" />
    </div>
  );
};

export default GroupEllipsisPopupButton;
